import { render } from "./talkDetails.vue?vue&type=template&id=5ebd0a08&scoped=true"
import script from "./talkDetails.vue?vue&type=script&lang=js"
export * from "./talkDetails.vue?vue&type=script&lang=js"

import "./talkDetails.vue?vue&type=style&index=0&id=5ebd0a08&scoped=true&lang=css"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ebd0a08"]])

export default __exports__